<template>
  <div v-if="article && this.$route.name === 'article' && isActive" id="tool-overlay" class="overlay" :class="category.slug">
    <div class="flex items-center header">
      <div class="icon-container">
        <div class="overlay-icon" :class="tool.class"></div>
      </div>
      <h5 v-html="tool.name"></h5>
      <div class="button-container">
        <close-overlay-button @click.native="closeOverlay" :category="category.slug"></close-overlay-button>
      </div>
    </div>
    <div class="body">
      <div v-if="isGlossary" class="body-content">
        <div v-for="term in article.glossary_terms" class="glossary-term">
          <div class="body-3 term">{{ term.term }}</div>
          <div class="body-1 description">{{ term.description }}</div>
        </div>
      </div>
      <div v-if="isCiteThis">
        <citation :article="article"></citation>
      </div>
      <div v-if="isSourceNotes">
        <div class="body-1 body-content source-notes" v-html="article.source_notes"></div>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import CloseOverlayButton from "@/component/CloseOverlayButton";
  import Citation from '@/views/Student/Article/Citation';

  export default {
    name: 'ToolOverlay',

    components: {
      CloseOverlayButton,
      Citation
    },

    props: ['tool'],

    computed: {
      ...mapGetters({
        category: 'category',
        article: 'selectedArticle'
      }),
      isGlossary: function () {
        return this.tool.name === 'Glossary';
      },
      isCiteThis: function () {
        return this.tool.name === 'Cite This';
      },
      isSourceNotes: function () {
        return this.tool.name === 'Source Notes';
      },
      isActive: function () {
        return this.isGlossary || this.isCiteThis || this.isSourceNotes;
      }
    },

    methods: {
      closeOverlay: function () {
        this.$emit('overlay-closed');
      }
    }

  }
</script>

<style lang="scss">
  #tool-overlay.overlay {
    @apply bg-grey-5;
    min-height: 500px;
    height: calc(100vh - 375px);
    width: 100%;
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.3) -8px 8px 8px;
    z-index: 10;

    @media (min-width: config('screens.lg')) {
      margin-left: 90px;
      width: calc(100% - 90px);
    }

    .header {
      height: 120px;
      margin-bottom: 15px;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 16px;
        left: 0;
        bottom: -16px;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
      }

      h5 {
        padding-left: 15px;
      }

      .icon-container{
        width: 65px;
        margin-left: 30px;
        margin-right: 15px;
      }

      .button-container {
        margin-left: auto;
        margin-right: 80px;
      }

      .overlay-icon {

        height: 50px;
        width: 65px;
        padding: 30px;

        &.glossary {
          background: no-repeat url("../assets/images/104-lrn-spt-prof-tool-icon-gloss-50.svg") center;
        }

        &.cite-this {
          background: no-repeat url("../assets/images/106-lrn-spt-prof-tool-icon-cite-50.svg") center;
        }

        &.source-notes {
          background: no-repeat url("../assets/images/105-lrn-spt-prof-tool-icon-note-59.svg") center;
        }
      }
    }

    .body {
      height: calc(100vh - 510px);
      min-height: 366px;
      margin-top: -16px;
      overflow-y: scroll;
      @apply px-3;

      @media (min-width: config('screens.lg')) {
        padding-left: 125px;
      }

      @media (min-width: config('screens.xl')) {
        width: 925px;
        @apply pr-0;
      }

      .glossary-term {
        padding: 15px 0;
      }

      .body-content {
        margin-top: 40px;
      }
    }

    .source-notes {
      word-break: break-all;
    }

    .footer {
      position: absolute;
      bottom: 0;
      height: 16px;
      width: 100%;
    }

    &.basketball {
      h5 {
        @apply text-c1-b;
      }

      .term {
        @apply uppercase text-c1-g;
      }

      .footer {
        @apply bg-c1-g;
      }
    }

    &.football {
      h5 {
        @apply text-c2-b;
      }

      .term {
        @apply uppercase text-c2-g;
      }

      .footer {
        @apply bg-c2-g;
      }
    }

    &.baseball {
      h5 {
        @apply text-c3-b;
      }

      .term {
        @apply uppercase text-c3-g;
      }

      .footer {
        @apply bg-c3-g;
      }
    }

    &.soccer {
      h5 {
        @apply text-c4-b;
      }

      .term {
        @apply uppercase text-c4-g;
      }

      .footer {
        @apply bg-c4-g;
      }
    }

    &.more-sports {
      h5 {
        @apply text-c5-b;
      }

      .term {
        @apply uppercase text-c5-g;
      }

      .footer {
        @apply bg-c5-g;
      }
    }

    &.olympics {
      h5 {
        @apply text-c6-b;
      }

      .term {
        @apply uppercase text-c6-g;
      }

      .footer {
        @apply bg-c6-g;
      }
    }

    &.hockey {
      h5 {
        @apply text-c7-b;
      }

      .term {
        @apply uppercase text-c7-g;
      }

      .footer {
        @apply bg-c7-g;
      }
    }

    &.tennis {
      h5 {
        @apply text-c8-b;
      }

      .term {
        @apply uppercase text-c8-g;
      }

      .footer {
        @apply bg-c8-g;
      }
    }
  }
</style>
